const HERO_BG =
  'https://readdy.ai/api/search-image?query=Stylized%20abstract%20background%20of%20manga%20comic%20reading%20blending%20into%20smooth%20data%20saving%20energy%20flow%20waves%2C%20emerald%20green%20and%20teal%20palette%20with%20subtle%20halftone%20dots%2C%20minimal%20clean%20artwork%2C%20soft%20ambient%20glow&width=1600&height=900&seq=hero-bg-2026&orientation=landscape';

const COMIC_PANEL =
  'https://readdy.ai/api/search-image?query=Vibrant%20modern%20manhua%20comic%20panel%20illustration%20with%20dynamic%20action%20scene%2C%20energetic%20character%20with%20bold%20ink%20outlines%2C%20emerald%20green%20and%20teal%20color%20grading%2C%20halftone%20dots%20and%20speed%20lines%20background%2C%20clean%20minimal%20composition&width=600&height=800&seq=comic-panel-2026&orientation=portrait';

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[92vh] items-center overflow-hidden bg-primary-950">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${HERO_BG}')` }}
        role="img"
        aria-label="漫画人极速版省流主题背景"
      ></div>
      <div className="absolute inset-0 bg-gradient-to-br from-primary-950/90 via-primary-900/80 to-background-950/70"></div>

      <div className="relative z-10 mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 pb-16 pt-28 md:px-6 lg:grid-cols-2 lg:gap-8 lg:pt-24">
        <div className="text-center lg:text-left">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
            <i className="ri-flashlight-fill"></i>
            专为低流量用户设计
          </span>
          <h1 className="mt-5 font-heading text-3xl leading-snug text-background-50 md:text-5xl">
            漫画人极速版
            <span className="mt-2 block text-accent-300">省流看漫画，流量更安心</span>
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base lg:mx-0">
            省流画质、压缩图模式、流量监控与仅WiFi下载一键开启。无论上下班路上还是户外流量告急，
            都能用最少的数据，流畅追完每一话。
          </p>

          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row lg:justify-start sm:justify-center">
            <a
              href="#download"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
            >
              立即体验省流
            </a>
            <a
              href="#guide"
              className="whitespace-nowrap rounded-md border border-background-200/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              查看省流指南
            </a>
          </div>

          <div className="mt-10 flex items-center justify-center gap-8 lg:justify-start">
            {[
              { num: '62%', label: '最高流量节省' },
              { num: '8MB+', label: '每章少用流量' },
              { num: '0', label: '后台偷偷跑量' },
            ].map((s) => (
              <div key={s.label} className="text-center lg:text-left">
                <p className="font-heading text-xl text-background-50 md:text-2xl">{s.num}</p>
                <p className="mt-1 text-xs text-background-100/80">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="relative mx-auto w-60 md:w-72">
          <div className="relative overflow-hidden rounded-[2.2rem] border-4 border-background-50/20 bg-primary-950 shadow-2xl">
            <div className="mx-auto mt-3 h-5 w-20 rounded-full bg-background-50/20"></div>
            <img
              src={COMIC_PANEL}
              alt="漫画人极速版省流画质下的漫画阅读界面"
              className="mt-3 h-80 w-full object-cover object-top md:h-96"
            />
          </div>

          <span className="absolute -left-6 top-10 flex items-center gap-2 rounded-md bg-background-50 px-3 py-2 text-xs font-medium text-foreground-800">
            <i className="ri-battery-saver-line text-accent-600"></i>
            本月已省 1.2GB
          </span>
          <span className="absolute -right-4 bottom-16 flex items-center gap-2 rounded-md bg-primary-500 px-3 py-2 text-xs font-medium text-background-50">
            <i className="ri-checkbox-circle-line"></i>
            仅WiFi下载已开启
          </span>
        </div>
      </div>
    </section>
  );
}